import { useAppState } from '../../../AppStateProvider';
import getTrackingLocation from '../getTrackingLocation';
import { allTrackers } from '../tracking';

export const useDispatchTrackEventWithLocation = () => {
  const { url, trackingSectionName } = useAppState();
  const dispatchTrackEvent = (event: string, action: string, eventName: string) => {
    allTrackers.dispatchTrackEvent(event, action, eventName, {
      location: getTrackingLocation(url),
      ...(trackingSectionName ? { section: trackingSectionName } : {}),
    });
  };
  return dispatchTrackEvent;
};
